import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useWindowDimensions } from "../../lib/uiFunctions";
import "./index.less";
import motionConfig from "./../../config/motion.json";

export default props => {
  const { background, publicPath } = props;
  const { height, width } = useWindowDimensions();
  let videoUrl =
    "https://cdn.wp.ytadvisors.com/wp-content/uploads/sites/13/2021/04/06141152/Inner-Peace-Bumper-open-V2-1-1.mp4";
  if (width && width < height) {
    videoUrl =
      "https://cdn.wp.ytadvisors.com/wp-content/uploads/sites/13/2021/04/13132110/Lucy-Logo-IPT-phone.mp4";
  }

  const [isLoaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!isLoaded) setLoaded(true);
  }, [isLoaded]);

  return (
    <>
      {isLoaded && publicPath && (
        <>
          <motion.div {...motionConfig.intro}>
            <video className="videot" id="videot" autoPlay muted playsInline>
              <source src={videoUrl} type="video/mp4" />
            </video>
          </motion.div>
          <motion.div
            {...motionConfig.bg}
            style={{ backgroundImage: `url(${background})` }}
          />
        </>
      )}
    </>
  );
};
